

































































import Vue from 'vue';
import * as api from '@/api';
import CardContainer from '@/components/CardContainer.vue';
import CardTable from './CardTable.vue';

export default Vue.extend({
    components: {
        CardTable,
        CardContainer,
    },
    data() {
        return {
            dataLoading: true,
            search: '',
            downloadedProductList: [] as api.ProductListItem[],
        };
    },
    async created() {
        this.getUserProductsDownloaded();
    },
    methods: {
        async getUserProductsDownloaded() {
            this.dataLoading = true;
            const res = await api.getUserProductsDownloaded();
            if (!api.error(res)) {
                this.downloadedProductList = res.data.filter((data) => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()));
            }
            this.dataLoading = false;
        },
        update(id: number) {
            console.log(id);
        },
        navToProductDetail(product) {
            // this.$store.commit('currentProductInfo', product);
            const path = `/product/${product.productId}`;
            const { href } = this.$router.resolve({
                path,
            });
            window.open(href, '_blank');
        },
        navToBrandDetail(product) {
            this.$router.push({
                path: `/brand/${product.brandId}`,
            });
        },
    },
});
